import { watchImmediate } from "@vueuse/core";
import { computed } from "vue";

const INLINE_LINK = "appearance-link-inline";

/**
 * Sets `--inline-link-display` on the host so its layout follows the variant in effect:
 * - `inline` while that is `appearance-link-inline` and `block-sm` is not active
 * - `inline-grid` while that is `appearance-link-inline` and `block-sm` is active, or while a
 *   small-screen variant replaces an `appearance-link-inline` default
 * - unset otherwise, leaving the host's own display
 *
 * @param {HTMLElement | null} host
 * @param {{ variant: string }} props - The element's props.
 * @param {import("vue").Ref<string>} variant - The variant in effect, small-screen variant included.
 * @param {import("vue").Ref<boolean>} isBlockSmActive - Whether `block-sm` applies at this viewport.
 */
export function useInlineLinkHost(host, props, variant, isBlockSmActive) {
  const hostDisplay = computed(() => {
    if (variant.value === INLINE_LINK) {
      return isBlockSmActive.value ? "inline-grid" : "inline";
    }

    if (props.variant === INLINE_LINK) {
      return "inline-grid";
    }

    return undefined;
  });

  function applyHostDisplay(display) {
    if (display) {
      host?.style.setProperty("--inline-link-display", display);
    } else {
      host?.style.removeProperty("--inline-link-display");
    }
  }

  watchImmediate(hostDisplay, applyHostDisplay);
}
